import React, { useState } from 'react'
import LoginForm from '../login/LoginForm'
import PalexLogo from '../header/PalexLogo'
import { withRouter, useHistory } from 'react-router-dom'
import { getTokenAndSetInLocalStorage } from '../../utils/token'
import { routes } from '../../constantes/routes'
import { authApi } from '../../api/authApi'
import { swalAlertError } from '../../utils/swalAlert'
import { version } from '../../../package.json'



const LoginContainer = () => {
  const history = useHistory()

  const [inputs, setinputs] = useState({
    Email: '',
    Password: '',
  })

  const [isDisable, setIsDisable] = useState(false)

  const handleChange = (event) => {
    const value = event.target.value
    const name = event.target.name

    setinputs((inputs) => ({ ...inputs, [name]: value }))
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    setIsDisable(true)
    try {
      const response = await authApi.login(inputs)
      // Despues de autentificarte guardamos el token en localStorge
      getTokenAndSetInLocalStorage(response.data.token)
      history.push(routes.MAIN)
    } catch (error) {
      swalAlertError(error.response.data || error.response.statusText)
      setIsDisable(false)
    }
  }

  const validateForm = () => {
    return inputs.Email.length > 0 && inputs.Password.length > 0
  }

  return (
    <>
      <div className='gradient-container'></div>
      <div className='frameless-login'>
        <div className='login-wrap'>
          <PalexLogo />
          <div className='login-form'>
            <h2>Iniciar Sesión</h2>
            <LoginForm
              handleChange={handleChange}
              handleSubmit={handleSubmit}
              inputs={inputs}
              isDisable={isDisable || !validateForm()}
            />
          </div>
        </div>
      </div>
      <div style={{ pointerEvents: "none", opacity: 0.2, position: 'absolute', bottom: '20px', right: '20px', color: 'black', fontSize: '12px' }}>
        {version}
      </div>
    </>
  )
}

export default withRouter(LoginContainer)
